<ap-drawer
  [visible]="showDrawer"
  (visibleChange)="visibleChange($event)"
  [placement]="'right'"
  [mask]="false"
  [drawerTitle]="'entity.add' | translate"
  [resizable]="false">
  @if (showDrawer) {
    <hr width="100%" size="2" />
    <gstar-upsert-entity
      (updateValues)="updateValues($event)"></gstar-upsert-entity>
    <hr width="100%" size="2" />
  }
  <ng-template ngTemplate="footer">
    <ap-button
      btnType="secondary"
      [label]="'shared.cancel' | translate"
      (click)="visibleChange(false)" />
    <ap-button
      [disabled]="!entityForm.valid"
      icon="plus-outline"
      btnType="primary"
      icon="plus-outline"
      [label]="'entity.add' | translate"
      class="ap-pl-spacing-5"
      (click)="addEntity()" />
  </ng-template>
</ap-drawer>
